import { register } from "../src/custom_elements";

const props = {
  embedHost: window.sparkleEmbedApiHost,
};

register(props);
